// =====================================================================================================================
// ========== COMPANIES PAGE
//
// Rationale: this component is intentionally minimal — it owns only the selection state and a refresh counter.
// All data fetching and mutation logic lives inside CompaniesForm and CompaniesTable respectively, keeping
// concerns separated and making each child independently testable.
//
// The `refreshTrigger` counter is incremented by `handleSuccess` (called after any successful mutation).
// CompaniesTable watches it in a useEffect dep array and re-fetches when it changes, giving us a clean
// parent→child notification channel without prop-drilling data.
// =====================================================================================================================

import React, { useState, useCallback } from "react"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid2"
import Typography from "@mui/material/Typography"
import CompaniesForm from "./CompaniesForm"
import CompaniesTable from "./CompaniesTable"

export default function Companies({ supabase }) {

    const [selectedCompanyId, setSelectedCompanyId] = useState(null)
    const [refreshTrigger,    setRefreshTrigger]    = useState(0)

    // Called by the form after a successful insert, update, or delete.
    // Clears the selection (so the form resets to "add" mode) and bumps the trigger so the table re-fetches.
    const handleSuccess = useCallback(() => {
        setSelectedCompanyId(null)
        setRefreshTrigger((prev) => prev + 1)
    }, [])

    return (
        <Box sx={{ width: "100%" }}>
            <Grid container spacing={4}>

                {/* ── FORM COLUMN ── */}
                <Grid size={{ xs: 12, lg: 4 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        {selectedCompanyId ? "Modifier une entreprise" : "Ajouter une entreprise"}
                    </Typography>
                    <CompaniesForm
                        supabase={supabase}
                        selectedCompanyId={selectedCompanyId}
                        onSuccess={handleSuccess}
                    />
                </Grid>

                {/* ── TABLE COLUMN ── */}
                <Grid size={{ xs: 12, lg: 8 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        Annuaire des entreprises
                    </Typography>
                    <CompaniesTable
                        supabase={supabase}
                        selectedCompanyId={selectedCompanyId}
                        setSelectedCompanyId={setSelectedCompanyId}
                        refreshTrigger={refreshTrigger}
                    />
                </Grid>

            </Grid>
        </Box>
    )
}